//
// Lazy Load Vanilla
//

import LazyLoad from 'vanilla-lazyload';

let lazyLoadInstance = null;

export const initLazyload = () => {
  if (!lazyLoadInstance) {
    lazyLoadInstance = new LazyLoad({
      class_applied: 'lz-applied',
      class_loading: 'lz-loading',
      class_loaded: 'lz-loaded',
      class_error: 'lz-error',
      class_entered: 'lz-entered',
      class_exited: 'lz-exited',
    });
    return lazyLoadInstance;
  }

  lazyLoadInstance.update();
  return lazyLoadInstance;
};

initLazyload();
